import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Benefits from './components/Benefits';
import CTA from './components/CTA';
import Footer from './components/Footer';

function App() {
  const [language, setLanguage] = useState('sl'); // Default to Slovenian

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <Header language={language} onLanguageChange={handleLanguageChange} />
      <Hero language={language} />
      <Features language={language} />
      <HowItWorks language={language} />
      <Benefits language={language} />
      <CTA language={language} />
      <Footer language={language} />
    </div>
  );
}

export default App;
